import { createSelector } from '@reduxjs/toolkit';
import { employeesForStaffingCalendar } from './employees-for-staffing-calendar';
import { holidaysForStaffingCalendar } from './holidays-for-staffing-calendar';
import type { EmployeeWithTimekeepingPeriods } from './employee-with-timekeeping-periods';
import { sortBy } from 'lodash';
import { timekeepingPeriods } from './timekeeping-periods';

export const employeesWithTimekeepingPeriods = createSelector(
  employeesForStaffingCalendar,
  holidaysForStaffingCalendar,
  function (employees, holidays) {
    const result: EmployeeWithTimekeepingPeriods[] = [];
    if (employees) {
      employees = sortBy(employees, (e) => e.name);
      employees.forEach((employee) => {
        const periods = timekeepingPeriods(employees, employee.uuid, holidays);
        result.push({
          uuid: employee.uuid,
          name: employee.name,
          periods: periods,
          forStaffing: employee,
        });
      });
    }
    return result;
  },
);
